import React from 'react';
import { IntegrationConf } from '../../models/integration';
import { ErrorInfo } from '../../models/Errors';
import {
    IntegrationCardListContainer,
    IntegrationCardListGroup,
    IntegrationCardList,
    IntegrationCardListContainerProps,
    IntegrationCardListProps,
    UserIntegrationDefinition,
} from '../../domain';
import { useIntegrationCardList } from '../../hooks/integrations/hooks';
// import { IntegrationItemAssetViewProps } from './asset/IntegrationItemAssetView';
import { useAuthenticatedContext } from '../../hooks';
import {
    useIntegrationDefinitions,
    useIntegrationTheme,
} from '../../hooks/integrations/hooks';

export interface IntegrationCardListViewProps {
    containerProps?: IntegrationCardListContainerProps;
    listProps?: IntegrationCardListProps;
    definitions: IntegrationConf[];
    // itemProps?: Pick<IntegrationItemAssetViewProps, 'isLoadingId' | 'isLoadingConnection'>;
    error?: ErrorInfo;
    renderItem: (props: { definition: UserIntegrationDefinition }) => React.ReactNode;
    suspense?: boolean;
}

export const IntegrationCardListView: React.FC<IntegrationCardListViewProps> = ({
    ...props
}) => {
    const context = useAuthenticatedContext();
    const theme = useIntegrationTheme();
    const definitions = useIntegrationDefinitions(context, { suspense: props.suspense });
    const { groups } = useIntegrationCardList({ definitions: definitions.data ?? [] });

    const renderItem = (definition: UserIntegrationDefinition) => {
        return props.renderItem({
            definition,
        });
    };

    return (
        <IntegrationCardListContainer {...props.containerProps}>
            {groups.map((group, index) => (
                <IntegrationCardListGroup
                    key={index}
                    title={group.title}
                    description={group.description}
                    theme={theme}
                    containerProps={props.listProps}
                >
                    <IntegrationCardList {...props.listProps}>
                        {group.definitions.map(renderItem)}
                    </IntegrationCardList>
                </IntegrationCardListGroup>
            ))}
            {props.children}
        </IntegrationCardListContainer>
    );
};
